export const IDENTIFICATION_RESOURCE_NAME = 'identification';
